export { ErrorBoundaryPage } from "./error-boundary-page";
